module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00622.b9b63c7c.jpg";